import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryCardColors = [
  'bg-primary-100',
  'bg-secondary-100',
  'bg-accent-100',
  'bg-background-200',
];

const categoryCardTextColors = [
  'text-primary-700',
  'text-secondary-700',
  'text-accent-700',
  'text-foreground-700',
];

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20social%20media%20influencer%20with%20smartphone%20and%20camera%2C%20modern%20flat%20design%2C%20warm%20coral%20pink%20color%20palette%2C%20minimal%20clean%20background%2C%20digital%20art%20style%2C%20soft%20shapes%2C%20trendy%20social%20media%20aesthetic&width=600&height=800&seq=category-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20movie%20clapperboard%20and%20spotlight%20on%20stage%2C%20modern%20flat%20design%2C%20warm%20mint%20green%20color%20palette%2C%20minimal%20clean%20background%2C%20digital%20art%20style%2C%20entertainment%20industry%20aesthetic%2C%20soft%20geometric%20shapes&width=600&height=800&seq=category-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20flaming%20breaking%20news%20megaphone%20with%20dynamic%20energy%2C%20modern%20flat%20design%2C%20warm%20amber%20orange%20color%20palette%2C%20minimal%20clean%20background%2C%20digital%20art%20style%2C%20trending%20news%20aesthetic%2C%20soft%20gradients&width=600&height=800&seq=category-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20financial%20chart%20and%20market%20data%20display%2C%20modern%20flat%20design%2C%20warm%20yellow%20brown%20color%20palette%2C%20minimal%20clean%20background%2C%20digital%20art%20style%2C%20business%20analytics%20aesthetic%2C%20soft%20abstract%20shapes&width=600&height=800&seq=category-04&orientation=portrait',
];

export default function CategoryGrid() {
  const displayCategories = categories.slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-12">
          <p className="text-xs text-foreground-500 font-medium tracking-widest mb-2 font-label">
            Browse by Category
          </p>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            分类
            <span className="font-heading italic font-normal text-foreground-700">精选</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {displayCategories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group cursor-pointer"
            >
              <div className={`${categoryCardColors[index]} rounded-3xl overflow-hidden hover:brightness-95 transition-all duration-300`}>
                <div className="aspect-[3/4] relative overflow-hidden">
                  <img
                    src={categoryImages[index]}
                    alt={`今日看料 - ${cat.name}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`今日看料 ${cat.name}分类`}
                  />
                </div>
                <div className="p-4 bg-background-50">
                  <div className="flex items-center gap-2">
                    <div className={`w-8 h-8 rounded-lg ${categoryCardColors[index]} flex items-center justify-center`}>
                      <i className={`${cat.icon} ${categoryCardTextColors[index]} text-sm`}></i>
                    </div>
                    <span className={`text-sm font-semibold ${categoryCardTextColors[index]}`}>
                      {cat.name}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-1.5 line-clamp-1">{cat.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {categories.length > 4 && (
          <div className="mt-8 flex justify-center">
            <div className="flex flex-wrap justify-center gap-3">
              {categories.slice(4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-2.5 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}